import React from 'react';

const HealthCaseUnderline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='49'
			height='48'
			fill='none'
			viewBox='0 0 49 48'
		>
			<path
				fill='#2d2d2d'
				d='M38 10.5H20v-3h10.5V9h3V7.5c0-1.65-1.35-3-3-3H20c-1.65 0-3 1.35-3 3v3h-4.5A4.513 4.513 0 008 15v19.5c0 2.475 2.025 4.5 4.5 4.5H38c2.475 0 4.5-2.025 4.5-4.5V15c0-2.475-2.025-4.5-4.5-4.5zm1.5 24c0 .825-.675 1.5-1.5 1.5H12.5c-.825 0-1.5-.675-1.5-1.5V15c0-.825.675-1.5 1.5-1.5H38c.825 0 1.5.675 1.5 1.5v19.5z'
			></path>
			<path
				fill='#2d2d2d'
				d='M32 21h-3v-3c0-.825-.675-1.5-1.5-1.5H23c-.825 0-1.5.675-1.5 1.5v3h-3c-.825 0-1.5.675-1.5 1.5V27c0 .825.675 1.5 1.5 1.5h3v3c0 .825.675 1.5 1.5 1.5h4.5c.825 0 1.5-.675 1.5-1.5v-3h3c.825 0 1.5-.675 1.5-1.5v-4.5c0-.825-.675-1.5-1.5-1.5zm-1.5 4.5h-3c-.825 0-1.5.675-1.5 1.5v3h-1.5v-3c0-.825-.675-1.5-1.5-1.5h-3V24h3c.825 0 1.5-.675 1.5-1.5v-3H26v3c0 .825.675 1.5 1.5 1.5h3v1.5zM41 45H9.5v3H41v-3z'
			></path>
		</svg>
	);
};

export default HealthCaseUnderline;
